import React from 'react';
import './PaymentMethodButton.css';
import { useTranslation } from 'react-i18next';

const PaymentMethodButton = ({ method, isSelected, onClick, defaultPayment = false, more = false, onClickMore }) => {
  const { t } = useTranslation();

  return (
    <button
      className={`payment-method-button ${isSelected ? 'selected' : ''} ${defaultPayment ? 'default' : ''}`}
      onClick={more ? onClickMore : onClick}
    >
      <span className="payment-icon">{method.icon}</span>
      <span className="payment-name">{method.name}</span>
      {more && (
        <span className="payment-more" onClick={onClickMore}>
          {t('packages.viewMore')}
        </span>
      )}
    </button>
  );
};

export default PaymentMethodButton;
